import React from 'react';
import { Modal } from 'antd';

const BulkActionModal = ({
  open,
  title,
  summaryLines = [],
  note,
  confirmText = '确认',
  cancelText = '取消',
  confirmLoading = false,
  confirmVariant = 'primary',
  onCancel,
  onConfirm,
  children
}) => (
  <Modal
    title={title}
    open={open}
    onCancel={onCancel}
    footer={
      <div style={footerStyle}>
        <button onClick={onCancel} style={buttonStyle('neutral')}>
          {cancelText}
        </button>
        <button onClick={onConfirm} disabled={confirmLoading} style={buttonStyle(confirmVariant, confirmLoading)}>
          {confirmLoading ? '处理中...' : confirmText}
        </button>
      </div>
    }
    width={560}
  >
    <div style={containerStyle}>
      {summaryLines.length > 0 && (
        <div style={summaryCardStyle}>
          {summaryLines.map((line) => (
            <div key={line} style={summaryLineStyle}>{line}</div>
          ))}
        </div>
      )}
      {note && <div style={noteStyle}>{note}</div>}
      {children}
    </div>
  </Modal>
);

const containerStyle = {
  display: 'grid',
  gap: '14px'
};

const summaryCardStyle = {
  padding: '14px 16px',
  borderRadius: '16px',
  background: '#f8fbff',
  border: '1px solid #dbeafe'
};

const summaryLineStyle = {
  color: '#1f2a44',
  lineHeight: 1.7,
  fontSize: '14px'
};

const noteStyle = {
  padding: '12px 14px',
  borderRadius: '14px',
  background: '#fff7e6',
  border: '1px solid #ffd591',
  color: '#8c5a12',
  fontSize: '13px',
  lineHeight: 1.6
};

const footerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px'
};

const buttonStyle = (variant = 'neutral', disabled = false) => {
  const variants = {
    neutral: {
      background: '#f3f6fb',
      color: '#1f2a44',
      boxShadow: 'inset 0 0 0 1px rgba(148, 163, 184, 0.22)'
    },
    primary: {
      background: 'linear-gradient(135deg, #1677ff 0%, #2457d6 100%)',
      color: '#ffffff',
      boxShadow: '0 10px 20px rgba(22, 119, 255, 0.22)'
    },
    success: {
      background: 'linear-gradient(135deg, #34c759 0%, #159947 100%)',
      color: '#ffffff',
      boxShadow: '0 10px 20px rgba(21, 153, 71, 0.2)'
    },
    danger: {
      background: 'linear-gradient(135deg, #ff5f6d 0%, #d9363e 100%)',
      color: '#ffffff',
      boxShadow: '0 10px 20px rgba(217, 54, 62, 0.2)'
    }
  };
  const style = variants[variant] || variants.neutral;
  return {
    padding: '7px 14px',
    background: style.background,
    color: style.color,
    border: 'none',
    borderRadius: '999px',
    boxShadow: disabled ? 'none' : style.boxShadow,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    opacity: disabled ? 0.7 : 1
  };
};

export default BulkActionModal;
